import { Col, HeaderRow, Row, Table } from "./styles";
import { ActionMenu } from "./ActionMenu";
import { useMemo, useState } from "react";
import { AcceptAsAccountPopup } from "../../../components/addAccountPopup/addAccountPopup";
import { ViewESUBPopup } from "./ViewESUBPopup";
import { DeletePopup } from "./DeletePopup";
import {
  ESubInfo,
} from "pages/newPreQualify/components/bondDetails/types";
import { deleteSingleEsub } from "../../../api/esub";
import { getEsubs } from "../../../data/actions/user";
import { useDispatch } from "react-redux";

type ESUBTableProps = { eSUBs: ESubInfo[]; institutionId: number; isLoading: boolean };

export const ESUBTable = ({ eSUBs, institutionId, isLoading }: ESUBTableProps) => {
  const dispatch = useDispatch();

  const [openViewESUBPopup, setOpenViewESUBPopup] = useState(false);
  const [openAddAccountPopup, setOpenAddAccountPopup] = useState(false);
  const [openConfirmDeletePopup, setOpenConfirmDeletePopup] = useState(false);
  const [esubIdToDelete, setEsubIdToDelete] = useState<number | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedESUB, setSelectedESUB] = useState<ESubInfo | null>(null);

  const [addAccountData, setAddAccountData] = useState<{
    accountId: string;
    companyName: string;
    submissionDate: string;
    accountType: string;
    address: string;
    uwOffice: string;
    contractorType: string;
    contractorGroup: string;
    financialYeDate: string;
    naicsCode: string;
    suite: string;
    postal: string;
    city: string;
    province: string;
    country: string;
  }>({
    accountId: "",
    accountType: "",
    address: "",
    companyName: "",
    contractorGroup: "",
    contractorType: "",
    financialYeDate: "",
    naicsCode: "",
    submissionDate: "",
    uwOffice: "",
    suite: "",
    postal: "",
    city: "",
    province: "",
    country: "",
  });

  const initialForm = useMemo(
    () => ({
      accountId: "",
      accountType: "",
      address: "",
      companyName: addAccountData.companyName,
      contractorGroup: "",
      contractorType: "",
      financialYeDate: "",
      naicsCode: "",
      submissionDate: "",
      uwOffice: addAccountData.uwOffice,
    }),
    [addAccountData]
  );

  const handleDeleteESUB = async (id: number) => {
    setIsDeleting(true);

    await new Promise((resolve) => setTimeout(resolve, 3000));

    try {
      deleteSingleEsub(
        id,
        () => {
          setIsDeleting(false);
          dispatch(getEsubs({ institution_id: institutionId }));
          setOpenConfirmDeletePopup(false);
          setEsubIdToDelete(null);
        },
        () => {
          setIsDeleting(false);
        }
      );
    } catch (e) {
      console.error(e);
      setIsDeleting(false);
    }
  };

  return (
    <>
      {!isLoading ? (
        <div style={{ display: "block" }}>
          <HeaderRow>
            <Col>Account Name</Col>
            <Col>Project Title</Col>
            <Col>City, State</Col>
            <Col>Project Owner Name</Col>
            <Col>Status</Col>
            <Col>Prepared/Submitted</Col>
            <Col>Actions</Col>
          </HeaderRow>
          {eSUBs.length > 0 ? (
            <Table>
              {eSUBs.map((row: ESubInfo, index: number) => (
                <Row key={index}>
                  <Col>{row.contractor_name}</Col>
                  <Col>{row.project_info.project_title}</Col>
                  <Col>
                    {row.project_info.owner_info.owner_city},{" "}
                    {row.project_info.owner_info.owner_province}
                  </Col>
                  <Col>{row.project_info.owner_info.owner_name}</Col>
                  <Col>{row.esub_status}</Col>
                  <Col>{row.updated_at}</Col>
                  <Col>
                    <ActionMenu
                      onViewESUB={() => {
                        setSelectedESUB(row);
                        setOpenViewESUBPopup(true);
                      }}
                      onAcceptAsAccount={() => {
                        const accountData = {
                          accountId: "",
                          accountType: "",
                          companyName: row.contractor_name || "",
                          contractorGroup: "",
                          contractorType: "",
                          financialYeDate: "",
                          naicsCode: "",
                          submissionDate: row.updated_at || "",
                          address: row.contractor_address || "",
                          suite: row.contractor_suite_number || "",
                          postal: row.contractor_postal_zip_code || "",
                          city: row.contractor_city || "",
                          province: row.contractor_province || "",
                          uwOffice: "",
                          country: row.contractor_country || "",
                        };

                        setAddAccountData(accountData);
                        setOpenAddAccountPopup(true);
                      }}
                      onReject={() => {}}
                      onDelete={() => {
                        setOpenConfirmDeletePopup(true);
                        setEsubIdToDelete(row.esubId);
                      }}
                    />
                  </Col>
                </Row>
              ))}
            </Table>
          ) : (
            <p style={{ textAlign: "center", marginTop: "150px" }}>
            No eSUBs found.
          </p>
          )}
        </div>
      ) : (
        <p style={{ textAlign: "center", marginTop: "150px" }}>Loading...</p>
      )}
      <ViewESUBPopup
        open={openViewESUBPopup}
        setOpen={setOpenViewESUBPopup}
        eSUB={selectedESUB}
      />
      <AcceptAsAccountPopup
        open={openAddAccountPopup}
        setOpen={setOpenAddAccountPopup}
        accountData={addAccountData}
      />
      <DeletePopup
        esubIdToDelete={esubIdToDelete}
        setEsubIdToDelete={setEsubIdToDelete}
        open={openConfirmDeletePopup}
        setOpen={setOpenConfirmDeletePopup}
        handleDelete={handleDeleteESUB}
        isDeleting={isDeleting}
      />
    </>
  );
};
